export default __webpack_public_path__ + "static/media/simbolo-branco-1.bbe6fa9a.png";